import { cn } from "@/lib/utils";

const CELLS = [
  { x: 2, y: 2, ghost: false },
  { x: 18, y: 2, ghost: true },
  { x: 2, y: 18, ghost: true },
  { x: 18, y: 18, ghost: false },
] as const;

export function LogoMark({
  size = 24,
  ghostOpacity = 0.26,
  className,
}: { size?: number; ghostOpacity?: number; className?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none"
      aria-hidden="true" className={cn("shrink-0", className)}>
      {CELLS.map((c) => (
        <rect key={`${c.x}-${c.y}`} x={c.x} y={c.y} width="12" height="12"
          rx="2.8" fill="currentColor" fillOpacity={c.ghost ? ghostOpacity : 1} />
      ))}
    </svg>
  );
}

export function LogoLockup({
  size = 24, collapsed = false, className,
}: { size?: number; collapsed?: boolean; className?: string }) {
  return (
    <span className={cn("flex items-center gap-2.5 min-w-0", className)}>
      <LogoMark size={size} />
      {!collapsed && (
        <span className="font-brand text-[15px] font-medium tracking-[-0.03em] truncate">
          leangrid
        </span>
      )}
    </span>
  );
}
